import { Branch } from '@medprev-web-app/api-graphql-client';
import { faTimes } from '@fortawesome/pro-light-svg-icons';

import { BranchAvatar } from './branch-avatar.component';

import { BranchContact } from '@/app/(main)/(pages)/_components/branches-section/branch-profile/branch-contact.component';
import { Sheet, SheetClose, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { formatBranchName } from '@/utils/formatters/branch';
import { Icon } from '@/components/ui/icon.component';
import useIsMobile from '@/hooks/use-is-mobile.hook';
import { BranchOpeningHours } from '@/app/(main)/(pages)/_components/branches-section/branch-profile/branch-opening-hours.component';

interface BranchProfileModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  branch: Branch;
}

export const BranchProfileModal = ({
  open,
  onOpenChange,
  branch,
}: BranchProfileModalProps) => {
  const branchName = formatBranchName(branch.name as string);
  const isMobile = useIsMobile();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side={isMobile ? 'bottom' : 'centerFit'}
        closingTagPosition="right"
        hasHeader
        className="p-0 border-none overflow-x-hidden outline-none outline-offset-0"
      >
        <SheetHeader>
          <div className="flex justify-between gap-2 px-6 pt-5 pb-4 items-center">
            <SheetTitle>
              <Typography
                variant={TypographyVariant.MODAL_TITLE}
                className="text-xl"
              >
                Unidade de atendimento
              </Typography>
            </SheetTitle>

            <SheetClose asChild className="text-gray-500 cursor-pointer self-start px-2 hover:bg-gray-50">
              <Icon icon={faTimes} size="xl" className="hover:text-gray-900 text-[1.625rem]" />
            </SheetClose>
          </div>
        </SheetHeader>

        <div className="max-h-[70vh] sm:max-h-[60vh] overflow-y-auto overflow-x-hidden pt-4 px-6 pb-6 flex flex-col items-center gap-4">
          <BranchAvatar branch={branch} />
          <Typography
            variant={TypographyVariant.MODAL_TITLE}
            className="text-center mb-3"
          >
            {branchName}
          </Typography>

          <hr className="w-full bg-gray-300" />

          <BranchContact branch={branch} className="mt-3" />

          <BranchOpeningHours branch={branch} />
        </div>
      </SheetContent>
    </Sheet>
  );
};
